import {TextareaVariable} from '../types'


// Build a token → definition lookup map for O(1) access during parse
// and live tokenisation. Callers rebuild the map when the source array
// changes (e.g. on `props.tokens` change).
export function textareaWithVariables_buildTokensMap(tokens: TextareaVariable[]): Map<string, TextareaVariable> {
    const m = new Map<string, TextareaVariable>()
    for (const t of tokens) m.set(t.token, t)
    return m
}
